/**
 * External dependencies
 */
import React from "react";
import PropTypes from "prop-types";

export default class ErrorBoundary extends React.PureComponent {
  static propTypes = {
    widgetConfiguration: PropTypes.object,
  };

  static defaultProps = {
    widgetProps: {},
  };

  state = {
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    const { errorInfo } = this.state;
    if (errorInfo) {
      return <div>error</div>;
    }
    return this.props.children;
  }
}
